export class BasicSystemConfig {

    public uid: string;
    public system: string;
    public configuration: string;
}
